<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import getSecret from '@utils/get-secret'

export default {
  page: {
    title: 'Forget Password',
    meta: [{ name: 'description', content: `Forget Password to ${getSecret('TITLE')}` }],
  },
  components: { Layout },
  data() {
    return {
      email: '',
      error: null,
      wait: false,
      tryingToReset: false,
      isResetError: false,
      isSuccess: false,
      successMessage: null
    }
  },
  computed: {
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null
    },
  },
  methods: {
    ...authMethods,
    toWait(){
			this.wait =  true
			setTimeout( () => this.wait = false, 360000) 
		},

    tryToReset() {
      this.tryingToReset = true
      // Reset the authError if it existed.
      this.error = null
      return this.forgotPasswordAction({
        email: this.email
      })
        .then((data) => {
          this.tryingToReset = false
          this.isResetError = false
          this.isSuccess = true
          this.successMessage = 'Hemos enviado un correo con las instrucciones para restablecer tu contraseña.'
          this.toWait()
        })
        .catch((error) => {
          this.tryingToReset = false
          this.isResetError = true
          this.isSuccess = false
          // this.error = "Internal Server Error"
          this.error = error.response.data.mensaje || "Internal Server Error"
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card bg-pattern">
          <div class="card-body p-4 pb-0">
            <div class="text-center m-auto">
              <a href="/"> 
                <span>
                  <b-img
                    v-if="getCompanyInfo && getCompanyInfo.dark_logo"
                    :src="getCompanyInfo.light_logo || require('@assets/images/logos/euro-logo.svg')"
                    alt="login"
                    fluid
                  />
                </span>
              </a>
              <p class="text-muted mb-4 mt-3">
                Ingrese su dirección de correo electrónico y le enviaremos un correo electrónico con instrucciones para restablecer su contraseña.
              </p>
            </div>

            <b-alert v-if="error" v-model="isResetError" variant="danger" dismissible>
              {{error}}
            </b-alert>

            <b-alert v-model="isSuccess" variant="success" dismissible>
              Le hemos enviado un correo electrónico con las instrucciones para restablecer su contraseña.
            </b-alert>

            <b-form @submit.prevent="tryToReset">
              <b-form-group
                id="email-group"
                :label="$t('email')"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="email"
                  type="email"
                  required
                  placeholder="Ingrese correo electrónico."
                ></b-form-input>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <p v-if="wait && !tryingToReset" class="text-center"> <b-spinner small type="grow"></b-spinner> Intenta de nuevo en los siguientes 5 minutos. Por favor espera...</p>
                <b-button  v-else type="submit" variant="primary" class="btn-block" :disabled="tryingToReset">    
                  <span v-if="!tryingToReset">
                    Restablecer Contraseña
                  </span>
                  
                  <b-spinner
                    v-if="tryingToReset"
                    small
                    label="Spinning"
                    variant="light"
                  >
                  </b-spinner>
                  
                </b-button>
              </b-form-group>
            </b-form>
          <!-- end card-body -->
          </div>
        <!-- end card -->
        </div>
      <!-- end col -->
      </div>
    <!-- end row -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
